<script>

let caracteristicaLinks={ id:Math.random(), itemLink:'en-curta.me/teste2'};
let links = [];
let linksObj = [];
let passagemModal=null;
export let loginPainel = ""

export let tipoPlano="Pro";
export let valorPlano="";
let valorAnual;
let custom;
let cupom="";
let promocao="";
let promocaoErro=false;
let validade="";
let modalPromocao=null;
let textoPromocao="";

$:valorPlano = sessionStorage.getItem("valorPlano");

$:tipoPlano2 = (sessionStorage.getItem("tipoPlano") || "").toUpperCase();

$:valorAnual="R$"+(valorPlano*12);
$:loginPainel =  localStorage.getItem("logado");
var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

$:custom=Base64.encode(loginPainel+"|"+tipoPlano+"|"+valorPlano);




let abrirModalLogout=false;


import Celula from "./celulamicrosite.svelte";
import CaixaDialogo from "./modal_pergunta.svelte";
import PayPal from "./comprapaypal.svelte";
import {createEventDispatcher } from 'svelte';
import {onMount} from "svelte";
import {Button,  
  ButtonGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader} from "sveltestrap";
const dispatch = createEventDispatcher();
onMount(()=>{
BuscarLista();
console.log(tipoPlano);
});
function BuscarLista(){
 linksObj = [];
     console.log('aqui');
     
  var data = new FormData();
  data.append("login", loginPainel);
  
	fetch('http://microsites.en-curta.me/svelte/consulta.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
  console.log(text);
  links =text.split("|");
  console.log(links);
  
  for (let i in links){
      console.log(links[i]);
        let obj = JSON.parse(links[i]);
        console.log(obj.link_resultado);
        linksObj=[...linksObj, obj]
  
  }
  
  }
  ); 
  
})
.catch((error) => {
  console.error('Error:', error);
 
});
} 
function ConfirmarLogout(){
         passagemModal={
         abrirModal:true,
         titulo:"Logout",
         mensagem:"Deseja efetuar logout",
         botaoNegativo:"Cancelar",
         botaoPositivo:"Confirmar"

     }
     console.log(passagemModal);
}
function Logout(){
     passagemModal=null;
     dispatch("Logout");
     
}

function ChamarPlanos(){
    console.log("chamarplanos1");
    dispatch("ChamarPlano","planos");
}
function ChecaCupom(){
 linksObj = [];
     console.log('aqui');
     
  var data = new FormData();
  data.append("cupom", cupom);
  
	fetch('http://microsites.en-curta.me/svelte/cupom.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
    console.log("retorno "+text);
    if(text==""){
      promocaoErro=true;
    }
  let obj = JSON.parse(text);

  try {
    promocao=obj.nome_promocao;
    valorPlano=obj.valor_plano;
    validade=obj.validade;
    tipoPlano=obj.tipo_plano;
    textoPromocao=obj.texto_promocao;
    promocaoErro=false;
  } catch (error) {
    promocaoErro=true;
  }
  

  }
  ); 
  
})
.catch((error) => {
  console.error('Error:', error);
  promocaoErro=true;
});
} 

function Adquirir(){
 linksObj = [];
     console.log('aqui');
     
  var data = new FormData();
  data.append("tipoPlano", tipoPlano);
  data.append("cupom", cupom);
  data.append("login", loginPainel);
  
	fetch('http://microsites.en-curta.me/svelte/adquirir.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
    console.log("retorno"+text);
  if(text=="sucesso"){
      sessionStorage.setItem("tipoUsuario", tipoPlano);
      modalPromocao={
        abrirModal:true,
         titulo:"Sucesso",
         mensagem:"Plano adquirido com sucesso",
         botaoNeutro:"OK"


      }
    }
  }
  ); 
  
})
.catch((error) => {
  console.error('Error:', error);
 
});
} 

</script>







<section>

<body class='back'>

{#if passagemModal!=null}
<CaixaDialogo passagemModal={passagemModal}
 on:CliqueNegativo={()=>passagemModal=null}
 on:CliquePositivo={Logout}

 />
{/if}
{#if modalPromocao!=null}
<CaixaDialogo passagemModal={modalPromocao}
 on:CliqueNeutro={()=>{location.reload(true);}}
 

 />
{/if}
<div class=" container ">
	<div class="d-flex justify-content-center h-100 ">
		<div class="card ">
			<div class="card-header flex-nowrap">
				<h3 class="float-left">Comprar plano  {tipoPlano2}</h3><Button on:click={ConfirmarLogout} class="float-right" >Logout</Button>
				
			</div>
			<div class="card-body">
				<div class="conteiner">
                        <div class="row">
                    

                                <div class="col-lg-6 col-12  border-right mb-5">
                                          {#if promocao==""}  
                                        <h4>Plano {tipoPlano2}</h4>

                                        <p>Você será direcionado ao PayPal para efetuar assinatura de plano {tipoPlano2}. </p>
                                            <h4>Valor do plano R$ {valorPlano} por mês (contratação anual)</h4> 
                                            <h6><p>Valor total do plano {valorAnual}</p>  </h6>  
                                            {:else}
                                              {@html textoPromocao}
                                            {/if}                                    
                                 <hr>  
                                 
                                 <h5 class="">Cupom promocional:</h5>
                                    
                                {#if promocao==""}
                                 <input  class="col-6" type="text" placeholder="Digite um cupom" bind:value={cupom}/>
                             
                                <button on:click|preventDefault={ChecaCupom} class="btn btn-sm btn-outline-secondary">Checar</button>
                                {:else}
                                 <input  class="col-6" disabled type="text" placeholder="Digite um cupom" bind:value={cupom}/>
                             
                                <h6>Cupom válido. </h6>        
                               <p>
                               Promoção: {promocao}
                               </p> 
                                {/if} 
                                {#if promocaoErro}
                              <h5 class="vermelho">Cupom invalido</h5>        
                                {/if}                                                       
                                
                                
                                </div>
                                <div class="col-lg-6 col-12 align-middle text-center">
                                <table style="height: 100% ;"   class="col-12 text-center">
                                    <tbody>
                                        <tr>
                                        
                                        <td class="align-middle"> 
                                        <!--
                                        <form  action="https://www.sandbox.paypal.com/cgi-bin/webscr" method="post" target="_top">
                                        <input type="hidden" name="cmd" value="_s-xclick">
                                        <input type="hidden" name="hosted_button_id" value="TQD4W4ATWPRQ4">
                                        <input  type="image" src="https://www.sandbox.paypal.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
                                        <img alt="" border="0" src="https://www.sandbox.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1">
                                        </form>    </td>
                                       -->
                                       {#if promocao==""}
                                       {#if tipoPlano2 =="PLUS"}
                                      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                                          <input type="hidden" name="cmd" value="_s-xclick">
                                          <input type="hidden" name="hosted_button_id" value="8RPNHSPDQ62SU">
                                          <input type="hidden" name="custom" value="{custom}">
                                          <input type="image" src="https://www.paypalobjects.com/pt_BR/BR/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal - A maneira fácil e segura de enviar pagamentos online!">
                                      <img alt="" border="0" src="https://www.paypalobjects.com/pt_BR/i/scr/pixel.gif" width="1" height="1">
                                      </form>
                                      {:else if tipoPlano2=="PRO"}

                                      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                                        <input type="hidden" name="cmd" value="_s-xclick">
                                        <input type="hidden" name="custom" value="{custom}">
                                        <input type="hidden" name="hosted_button_id" value="4YMZ945C48B66">
                                        <input type="image" src="https://www.paypalobjects.com/pt_BR/BR/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal - A maneira fácil e segura de enviar pagamentos online!">
                                        <img alt="" border="0" src="https://www.paypalobjects.com/pt_BR/i/scr/pixel.gif" width="1" height="1">
                                      </form>
                                      {/if}
                                      {:else}
                                      <button on:click|preventDefault={Adquirir} class="btn btn-sm btn-outline-secondary">Adquirir promoção</button>
                          
                                      {/if}



 </td>

                                        </tr>
                                    </tbody>
                                    </table>
                                                                        
                                                                                                                  
                                
                                
                                
                                </div>
                                
                        
                        </div>
               
                </div>


                 
                    
					
					
				
			</div>
			
			<div class="card-footer">
				<div class="d-flex justify-content-center links">
					 
                                 
                    <Button on:click={ChamarPlanos}>Voltar</Button> 
                                 
				</div>
				
			</div>
		</div>
	</div>
</div>


</body>

</section>



<style>


@import url('https://fonts.googleapis.com/css?family=Numans');
body{
    
    background-color: black}
.back{
background-image: url('/img/back.jpg');
background-size: cover;
background-repeat: no-repeat;

height: 100%;
padding: 10px;
font-family: 'Numans', sans-serif;

}

.container{
height: 100%;
align-content: center;
}

.card{
height: 580px;
margin-top:100px;
margin-bottom: 30px;
width: 95%;
background-color: rgba(255,255,255,1) !important;
}

.social_icon span{
font-size: 60px;
margin-left: 10px;
color: #FFC312;
}

.social_icon span:hover{
color: white;
cursor: pointer;
}

.card-header h3{
color: black;
}

.social_icon{
position: absolute;
right: 20px;
top: -45px;
}

.input-group-prepend span{
width: 50px;
background-color: #FFC312;
color: black;
border:0 !important;
}

input:focus{
outline: 0 0 0 0  !important;
box-shadow: 0 0 0 0 !important;

}

.remember{
color: white;
}

.remember input
{
width: 20px;
height: 20px;
margin-left: 15px;
margin-right: 5px;
}

.login_btn{
color: black;
background-color: #FFC312;
width: 100px;
}

.login_btn:hover{
color: black;
background-color: white;
}

.links{
color: white;
}
.links a{
margin-left: 4px;
}
.tabular{
	margin-left:  20px;
}

.borda-esquerda{
    height: 500px;
    border-style: solid;
    border-color: gray;
    border-width: 0px 0.5px 0px 0px;
    
}
.scrool{
    height: 400px;
    overflow:auto;
    padding-right: 50px
}
.vermelho{
  color:red;
}
</style>